import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col items-center justify-center gap-6 px-4 py-12">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Citilux Coach</CardTitle>
          <CardDescription>AI-разбор консультаций продавцов</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <p className="text-sm text-muted-foreground">
            Загружайте аудио консультаций и получайте разбор с тегами, чек-листом и рекомендациями.
          </p>
          <Button asChild>
            <Link to="/login">Войти</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
